export default __webpack_public_path__ + "static/media/why-choose-us.b06086ce.png";